/**
 * Flash hotel room tiles are rendered twice (mobile + desktop) with the same
 * `ScrollAnchor` id. Prefer the copy that is actually visible.
 */
function isDisplayedOfferPageRoomAnchor(element: Element): boolean {
  if (typeof element.checkVisibility === 'function') {
    return element.checkVisibility()
  }
  return (element as HTMLElement).offsetParent !== null
}

export function offerPageRoomAnchorExists(roomTypeId: string): boolean {
  return !!document.getElementById(roomTypeId)
}

function findOfferPageRoomAnchor(roomTypeId: string): Element | undefined {
  const anchors = [...document.querySelectorAll(`#${CSS.escape(roomTypeId)}`)]
  const displayed = anchors.find(isDisplayedOfferPageRoomAnchor)
  if (displayed) return displayed

  // Older Safari has no `checkVisibility`. Do not fall back to a copy that
  // already reported itself hidden — that is usually `display: none`.
  if (anchors.length && anchors.every(element => typeof element.checkVisibility !== 'function')) {
    return anchors[0]
  }

  return undefined
}

function scrollToVisibleOfferPageRoom(roomTypeId: string): boolean {
  const target = findOfferPageRoomAnchor(roomTypeId)
  if (!target) return false
  target.scrollIntoView({ behavior: 'auto' })
  return true
}

export default scrollToVisibleOfferPageRoom
